export enum ButtonType {
    Primary = "primary",
    Secondary = "secondary",
    // Farbvariante statt Hierarchiestufe: Himmelblau ist laut Brand Guidelines
    // eine Hintergrundfarbe, deshalb traegt die Schrift hier den Kontrast.
    Blue = "blue"
}
